// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  cart: icon('ic_cart'),
  user: icon('ic_user'),
  booking: icon('ic_booking'),
  dashboard: icon('ic_dashboard'),
  invoice: icon('ic_invoice'),
  calendar: icon('ic_calendar'),
  file: icon('ic_file'),
  language: icon('ic_language'),
  banking: icon('ic_banking'),
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    items: [
      // Intranet Items
      {
        title: 'Dashboard',
        path: PATH_DASHBOARD.intranetDashboard,
        icon: ICONS.dashboard,
        roles: ['admin', 'user'],
        type: 'intranet',
      },

      {
        title: 'Utenti',
        path: PATH_DASHBOARD.intranetUser.root,
        icon: ICONS.user,
        roles: ['admin'],
        type: 'intranet',
        children: [
          {
            title: 'Utenti Intranet',
            path: PATH_DASHBOARD.intranetUser.list,
            roles: ['admin'],
            type: 'intranet',
          },
          {
            title: 'Mediatori',
            path: PATH_DASHBOARD.intranetMediator.list,
            // icon: ICONS.user,
            roles: ['admin'],
            type: 'intranet',
          },
          {
            title: 'Account Clienti',
            path: PATH_DASHBOARD.clientUser.list,
            // icon: ICONS.user,
            roles: ['admin'],
            type: 'intranet',
          },
        ],
      },
      {
        title: 'Richieste',
        path: PATH_DASHBOARD.intranetBookings.list,
        icon: ICONS.booking,
        roles: ['admin', 'user'],
        type: 'intranet',
      },
      {
        title: 'fatturazione',
        path: PATH_DASHBOARD.intranetBookings.bookingCompleted,
        icon: ICONS.file,
        roles: ['admin', 'user'],
        type: 'intranet',
      },
      {
        title: 'Traduzioni',
        path: PATH_DASHBOARD.translationOrders,
        icon: ICONS.banking,
        roles: ['admin', 'user'],
        type: 'intranet',
      },
      {
        title: 'Fatture',
        path: PATH_DASHBOARD.invoice,
        icon: ICONS.invoice,
        roles: ['admin', 'user'],
        type: 'intranet',
      },
      {
        title: 'Lingue',
        path: PATH_DASHBOARD.languageList,
        icon: ICONS.language,
        roles: ['admin', 'user'],
        type: 'intranet',
      },
    ],
  },
];

export default navConfig;
